export default {
  addressTitle: 'Address',
  currentAddressTitle: 'Current Address',
  PO: 'PO BOX',
  RR: 'RR',
};
